// Copied from ClientSafeWeb
export enum ConclusieDiagnoseOption {
    geen_afwijkingen = 'Geen afwijkingen',
    ja = 'Ja',
    nog_geen_diagnose = 'Nog geen diagnose',
}

export function isConclusieDiagnoseOption(value: unknown): value is ConclusieDiagnoseOption {
    return (
        value === ConclusieDiagnoseOption.geen_afwijkingen ||
        value === ConclusieDiagnoseOption.ja ||
        value === ConclusieDiagnoseOption.nog_geen_diagnose
    );
}
